import { createTypedSxStyles } from '@opengov/capital-mui-theme';

// capital-mui-theme v37 gray50 token. Token not available in v36
const muiV37Gray50 = '#F8F8F8';

export const styles = createTypedSxStyles({
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '24px',
    backgroundColor: muiV37Gray50
  },
  dialogContent: {
    padding: '24px',
    minHeight: '345px'
  },
  dialogActions: {
    padding: '24px',
    backgroundColor: muiV37Gray50
  },
  actionButton: {
    minWidth: '80px'
  },
  loadingIcon: {
    marginLeft: '8px'
  }
});
